(function () {
  /* Any request that changes the cart. /cart.js (read-only) is intentionally not matched. */
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var link = document.getElementById('s81-cart-float-link');
    var countEl = document.getElementById('s81-cart-float-count');
    if (!link || !countEl) return;

    var bubble = countEl.parentNode;
    var current = parseInt(countEl.textContent, 10) || 0;
    var requestId = 0;

    function render(itemCount) {
      var count = typeof itemCount === 'number' ? itemCount : 0;
      link.classList.toggle('is-visible', count > 0);
      countEl.textContent = count < 100 ? String(count) : '99+';

      if (count !== current && count > 0 && bubble) {
        bubble.classList.remove('is-bump');
        void bubble.offsetWidth; /* restart the animation */
        bubble.classList.add('is-bump');
      }
      current = count;
    }

    /* Ask the server for the real cart; only the newest answer wins. */
    function refreshFromServer() {
      var id = ++requestId;
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (id === requestId) render(cart.item_count);
        })
        .catch(function () {});
    }

    /* Theme (Horizon) event: `cart:update`, detail.resource is the new cart. */
    document.addEventListener('cart:update', function (event) {
      var resource = event.detail && event.detail.resource;
      if (resource && typeof resource.item_count === 'number') {
        render(resource.item_count);
      } else {
        refreshFromServer();
      }
    });

    /* s81 sections (PDP, featured products, cart page) dispatch `cart:updated`
       with detail.cart — this is the event the float used to miss. */
    document.addEventListener('cart:updated', function (event) {
      var cart = event.detail && event.detail.cart;
      if (cart && typeof cart.item_count === 'number') {
        render(cart.item_count);
      } else {
        refreshFromServer();
      }
    });

    /* Safety net: whatever button/script changes the cart, re-read it once the
       request finishes. Covers quick-add, custom buttons and third-party code. */
    if (window.fetch && !window.__s81CartFloatFetchPatched) {
      window.__s81CartFloatFetchPatched = true;
      var nativeFetch = window.fetch;
      window.fetch = function (input) {
        var promise = nativeFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : input && input.url;
          if (url && CART_MUTATION.test(url)) {
            promise.then(refreshFromServer, function () {});
          }
        } catch (e) {}
        return promise;
      };
    }

    /* Back/forward cache restore, or the cart changed in another tab. */
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) refreshFromServer();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refreshFromServer();
    });
  });
})();
